import { MDM4U } from "../../data/OSSD/Grade12/MDM4U";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function MDM4UPage() {
    return (
        <div>
            <GradeCourseTemplate data={MDM4U} />
        </div>
    )
}